
import { Injectable } from '@angular/core';
import { BancoResponse } from 'src/app/global/interfaces/banco-response';
import { clipBoard } from 'src/app/global/interfaces/cuenta-abono.response';
import { TipoCuenta } from 'src/app/global/interfaces/tipo-cuenta';
import { DialogService } from 'src/app/view-model/services/dialog.service';

@Injectable({providedIn: 'root'})
export class ClipboardService {
    
    tiposCuenta:TipoCuenta[] = [];
    bancos: BancoResponse[] = [];


    constructor(
        private dialogServ: DialogService
    ) { 
        console.log('ClipboardService init')

    }


  setBancos(bancos: BancoResponse[]):void{
    this.bancos=bancos;
    this.tiposCuenta = bancos
    .map(b => b.relacion)
    .reduce((acc, val) => acc.concat(val), []);  
 }

  /* Modal pegar */
  modalCopiardatos():Promise<{action:string;dataParsed:clipBoard}> {
    return new Promise((resolve, reject) => {
      navigator.clipboard.readText().then((text) => {
        const dataParsed = this.parseClipboardText(text);
        const data = {
          title: 'Copia y pega tus datos bancarios',
          description: `
            <strong>Activa y usa los datos desde el portapapeles</strong> <br><br>
            Para activar la función pegar datos bancarios, presiona el botón Permitir que aparece arriba en tu navegador. <br><br>
            <strong>¿Deseas utilizar estos datos?</strong><br><br>
            <div class="card cardcuenta" style="width: 18rem;">
            <div class="card-body">
            <table class="table table-sm table-borderless" style="width:100%;">
              <tr>
                <td style="  padding: 8px;">Nombre</td>
                <td style="  padding: 8px;">${dataParsed.razonSocial ? dataParsed.razonSocial : 'No disponible'}</td>
              </tr>
              <tr>
                <td style="  padding: 8px;">RUT</td>
                <td style="  padding: 8px;">${dataParsed.rut ? dataParsed.rut : 'No disponible'}</td>
              </tr>
              <tr>
                <td style="  padding: 8px;">Cuenta</td>
                <td style="  padding: 8px;">${dataParsed.cuenta ? dataParsed.cuenta : 'No disponible'}</td>
              </tr>
              <tr>
                <td style="  padding: 8px;">Banco</td>
               <td style="  padding: 8px;">${dataParsed.banco && dataParsed.banco.descripcion ? dataParsed.banco.descripcion : 'No disponible'}</td>
              </tr>
              <tr>
                <td style="  padding: 8px;">Tipo de Cuenta</td>
                <td style="  padding: 8px;">${dataParsed.tipoCuenta ? dataParsed.tipoCuenta.descripcion : 'No disponible'}</td>
              </tr>
            </table></div></div><br><br>
          `,
          cancelButton: 'No por ahora',
          actionButton: 'Si, utilizar'
        };

        this.dialogServ.openTwoActionsDialog({ data }).afterClosed().subscribe(async (action) => {         
          resolve({action:action.action,dataParsed:dataParsed});        
        }, (err) => reject(err));
      }).catch(err => {
        console.error('Failed to read clipboard contents: ', err);
        reject(err)
      });

    });

}



/* Modal pegar */
modalConfirmardatos(dataParsed :{
    razonSocial:string;
    rutEmpresa:string;
    bancoElegido:{id:number,asString:string};
    numeroCuenta:string;
    tipCuentaElegida:{descripcion:string}

}):Promise<string> {

 return  new Promise((resolve, reject) => {
  const data = {
    title: 'Confirmación de datos',
    description: `Revisa y confirma que los datos ingresados son correctos antes de continuar. <br><br>
    <div class="alert  border rounded" role="alert">
    <div class="mr-2 infoicon"> </div>
    El abono de tu dinero no será efectuado, si estos datos no corresponden a una cuenta bancaria, existente y con vigencia.
    </div>
      <div class="card cardcuenta" style="width: 18rem;">
        <div class="card-body">
          <table class="table table-sm table-borderless" style="width:100%;">
            <tr>
              <td style="padding: 8px;">Nombre</td>
              <td style="padding: 8px;">${dataParsed.razonSocial ? dataParsed.razonSocial : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">RUT</td>
              <td style="padding: 8px;">${dataParsed.rutEmpresa ? dataParsed.rutEmpresa : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Cuenta</td>
              <td style="padding: 8px;">${dataParsed.numeroCuenta ? dataParsed.numeroCuenta : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Banco</td>
              <td style="padding: 8px;">${dataParsed.bancoElegido ? dataParsed.bancoElegido.asString : 'No disponible'}</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Tipo de Cuenta</td>
              <td style="padding: 8px;">${dataParsed.tipCuentaElegida ? dataParsed.tipCuentaElegida.descripcion : 'No disponible'}</td>
            </tr>
          </table>
        </div>
      </div><br><br>
    `,
    cancelButton: 'Editar datos',
    actionButton: 'Confirmar'
  };

        
          this.dialogServ.openTwoActionsDialog({ data }).afterClosed().subscribe(async (action) => {
            resolve(action.action);           
          },(e)=>{
            reject(e);
          });

  });

}


  /* Función para analizar el texto del portapapeles */
  private parseClipboardText(text: string) :clipBoard{
    const lines = text.split('\n');
    const dataParsed:clipBoard = {
        nombre : {
          nombresTitular: '',
          primerApellido:'',
          segundoApellido: ''
        },
      razonSocial: '',
      mail: '',
      rut: '',
      cuenta: '',
      banco:{
        id: 0,
        descripcion:''
    } ,
      tipoCuenta: undefined
    };

    console.log(lines);
    console.log('---------------');

    // Procesa cada línea para extraer la información requerida
    dataParsed.rut = this.getRutClip(lines);
    dataParsed.nombre= this.getNombresYApellidos(lines);
    dataParsed.razonSocial= this.getRazonSocial(lines);
    dataParsed.mail = this.getMailClip(lines);
    dataParsed.cuenta = this.getCuentaClip(lines);
    dataParsed.banco = this.getBancoClip(lines);
    dataParsed.tipoCuenta = this.getTipoCuentaClip(lines);

    console.log('---------------');
    console.log(lines);

    return dataParsed;
  }

  /* Funciones de extracción de datos (modificadas para retornar valores) */
  private getRazonSocial(lines: string[]) {        
       let result = '-'
        if ( !lines ||  lines.length === 0){
          return result;
        }
          const line = lines[0] ;
          /**EMPRESA  */
          result= line.trim();
        //lines.splice(0, 1);
        return result;
  }
  private getNombresYApellidos(lines: string[]) {            
    const detalleNombre : {
     // nombreCompleto:string,
      nombre : {
          nombresTitular: string;
          primerApellido:string;
          segundoApellido:string;
        }
     }={
     // nombreCompleto: '-',
      nombre:{nombresTitular:'',primerApellido:'',segundoApellido:''}
     };
     if ( !lines ||  lines.length === 0){
       return detalleNombre.nombre;
     }

     const words = lines[0].trim().split(' ');
     if (words.length >= 2) {
         if (words.length === 2) {
           detalleNombre.nombre.nombresTitular = words[0];
           detalleNombre.nombre.primerApellido = words[1];
         } else if (words.length === 3) {
           detalleNombre.nombre.nombresTitular = words[0];
           detalleNombre.nombre.primerApellido = words[1];
           detalleNombre.nombre.segundoApellido = words[2];
         } else if (words.length === 4) {
           detalleNombre.nombre.nombresTitular = words[0] + ' ' + words[1];
           detalleNombre.nombre.primerApellido = words[2];
           detalleNombre.nombre.segundoApellido = words[3];
         } else if (words.length === 5) {
           detalleNombre.nombre.nombresTitular = words[0] + ' ' + words[1] + ' ' + words[2];
           detalleNombre.nombre.primerApellido = words[3];
           detalleNombre.nombre.segundoApellido = words[4];
         }
         return detalleNombre.nombre;  
      }
  }


  private getMailClip(lines: string[]) {
    for (let i = 0; i < lines.length; i++) {
      lines[i] = lines[i].replace('\r', '').trim();
      if (lines[i].match(/^[a-zA-Z0-9]{1,}[a-zA-Z0-9_\-\\.~]*@[a-zA-Z0-9_\-\\.~]{1,}\.[a-zA-Z]{2,4}$/)) {
        const email = lines[i];
        lines.splice(i, 1);
        return email;
      }
    }
    return '-';
  }

  private getRutClip(lines: string[]) {
    let rutEncontrado= '-';
    for (let i = 0; i < lines.length; i++) {
      const rutSinPuntos = lines[i].split('.').join('');
      if (rutSinPuntos.match(/^[0-9]+[-|‐]{1}[0-9kK]{1}$/)) {
        rutEncontrado = lines[i];
        lines.splice(i, 1);
        return rutEncontrado;
      }
    }
    return rutEncontrado;
  }


  private getCuentaClip(lines: string[]) {
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].toString().replace(/\D/g, '');
      if (line.length > 0 && !isNaN(Number(line))) {
        const cuenta = line;
        lines.splice(i, 1);
        return cuenta;
      }
    }
    return '-';
  }

  private getBancoClip(lines: string[]) {
    for (const line of lines) {
      const banco = this.bancos.find(b => line.toLowerCase().includes(b.asString.toLowerCase()));
      if (banco) return { id: banco.id, descripcion: banco.asString };
    }
    return { id: 0, descripcion: '-' };
  }

  private getTipoCuentaClip(lines: string[]) {
    // Validar si hay tipos de cuenta disponibles
    if (!this.tiposCuenta || this.tiposCuenta.length === 0) {
      console.warn('No hay tipos de cuenta disponibles.');
      return undefined; // Devolver un valor por defecto si no hay tipos de cuenta
    }

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].toLowerCase().includes("cuenta")) {
        console.log('Cuenta: ', lines[i])
        const tipoCuenta = this.tiposCuenta.find(c => c.descripcion.toLocaleLowerCase().includes(lines[i].toLocaleLowerCase()))
        if (tipoCuenta) {
          lines.splice(i, 1);
          return tipoCuenta;
        }
      }
    }

    return undefined;
  }

    
}